var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnExpand = function SvgIcnExpand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7438_371796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16602 5.33366V4.00033C3.16602 3.6467 3.30649 3.30756 3.55654 3.05752C3.80659 2.80747 4.14573 2.66699 4.49935 2.66699H5.83268",
    stroke: "currentcolor",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16602 10.667V12.0003C3.16602 12.3539 3.30649 12.6931 3.55654 12.9431C3.80659 13.1932 4.14573 13.3337 4.49935 13.3337H5.83268",
    stroke: "currentcolor",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 2.66699H12.4993C12.853 2.66699 13.1921 2.80747 13.4422 3.05752C13.6922 3.30756 13.8327 3.6467 13.8327 4.00033V5.33366",
    stroke: "currentcolor",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 13.3327H12.4993C12.853 13.3327 13.1921 13.1922 13.4422 12.9422C13.6922 12.6921 13.8327 12.353 13.8327 11.9993V10.666",
    stroke: "currentcolor",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7438_371796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentcolor",
    transform: "translate(0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnExpand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_expand.e5736c5e.svg";
export { ForwardRef as ReactComponent };